import { EnvironmentProviders, inject, provideAppInitializer, Type } from '@angular/core';

// https://github.com/angular/angular/issues/25633#issuecomment-1521925481

export function eagerProvider<T extends Type<any>>(klass: T): [T, EnvironmentProviders] {
    return [
        klass,
        provideAppInitializer(() => {
            const initializerFn = ((klass: T) => {
                return () => Promise.resolve();
            })(inject(klass));
            return initializerFn();
        }),
    ];
}
